import React from "react";
import { getMaterialMasterData } from "./api";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import SubTable from "./SubTable";
import { Box, Typography } from "@mui/material";
import { lightTable } from "../../../styles/muiProps";
import { masterMaterialsColumns } from "./cols";

export default function MaterialRecords() {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const func = async () => {
      const data = await getMaterialMasterData();
      // console.log(data);
      setData(data);
    };
    func();
  }, []);
  console.log("material records :", data);

  const table = useMaterialReactTable({
    ...lightTable,
    columns: masterMaterialsColumns,
    data: data?.[0]?.id ? data.map((r) => ({ ...r, subRows: [] })) : [],
    enableTopToolbar: true,
    enableColumnFilters: true,
    enableColumnActions: true,
    initialState: { showColumnFilters: true },

    enableExpanding: true,
    renderDetailPanel: ({ row }) => (
      <SubTable
        data={data?.find((r) => r.id === row.original.id).subRows || []}
        mainRow={data?.find((r) => r.id === row.original.id)}
        key={row?.original?.id}
      />
    ),
  });
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ m: 1, mt: 0 }}>
        Material Records
      </Typography>

      <MaterialReactTable table={table} />
    </Box>
  );
}
